import { Route } from "react-router-dom";
import { ROUTES, toStandalonePath } from "./manifest";

export default function SciencePulseRoutes({ standalone = false } = {}) {
  return ROUTES.map((r) => (
    <Route
      key={r.name}
      path={standalone ? toStandalonePath(r.path, r.standalonePath) : r.path}
      element={r.element}
    />
  ));
}
